import * as components from './components'

export default [
  {
    path: '/catalog/list',
    component: components.CatalogList,
    name: 'catalogList',
    props: true
  },
  {
    path: '/catalog/:uuid/home',
    component: components.CatalogDetail,
    name: 'catalogDetail',
    props: true
  },
  {
    path: '/catalog/upload',
    component: components.CatalogUpload,
    name: 'catalogUpload',
    props: true
  },
  {
    path: '/catalog/skillTagUpload',
    component: components.CatalogSkillTagUpload,
    name: 'catalogSkillTagUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/catalog/routes.js